import React from "react";
import styles from "./index.module.scss";
export default class SpeechBubble extends React.Component {
    render() {
        return (React.createElement("div", { className: `${styles.bubble} ${this.props.className} ${this.props.border ? styles.border : ""}` }, this.props.children));
    }
}
